/* eslint-disable */
const CheckInDateRangeObjectValue = Backbone.Model.extend({
	defaults: {
		from: null,
		to: null
	}
});

export default CheckInDateRangeObjectValue;